import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/components/pages/home/Index.vue";
import VideoList from "@/components/pages/video/List.vue";
import VideoItem from "@/components/pages/video/Item.vue";
import Staff from "@/components/pages/Staff.vue";
import Institucional from "@/components/pages/Institucional.vue";
import Education from "@/components/pages/Education.vue";
import ProjectList from "@/components/pages/project/List.vue";
import ProjectItem from "@/components/pages/project/Item.vue";
import ArticleList from "@/components/pages/article/List.vue";
import ArticleItem from "@/components/pages/article/Item.vue";
import GalleryList from "@/components/pages/gallery/List.vue";
import GalleryItem from "@/components/pages/gallery/Item.vue";
import CommunicationList from "@/components/pages/communication/List.vue";
import CommunicationItem from "@/components/pages/communication/Item.vue";
import ScheduleList from "@/components/pages/schedule/List.vue";
import ScheduleItem from "@/components/pages/schedule/Item.vue";
import HomeworkList from "@/components/pages/homework/List.vue";
import HomeworkItem from "@/components/pages/homework/Item.vue";
import DocumentList from "@/components/pages/DocumentList.vue";
import Links from "@/components/pages/Links.vue";
import Tips from "@/components/pages/Tips.vue";
import Books from "@/components/pages/Books.vue";
import Contact from "@/components/pages/Contact.vue";
import Covid from "@/components/pages/Covid.vue";
import WebCanal from "@/components/pages/WebCanal.vue";
import Enem from "@/components/pages/Enem.vue";
import PreRegistration from "@/components/pages/PreRegistration.vue";
import UnderConstruction from "@/components/pages/fallback/UnderConstruction.vue";
import Error404 from "@/components/pages/fallback/Error404.vue";

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "Início",
    component: Home
  },
  {
    path: "/institucional/o-colegio",
    name: "O Colégio",
    component: Institucional,
    meta: {
      title: "O Colégio",
      mod: "about"
    }
  },
  {
    path: "/institucional/equipe",
    name: "Equipe",
    component: Staff
  },
  {
    path: "/institucional/quem-foi-jean-piaget",
    name: "Quem foi Jean Piaget?",
    component: Institucional,
    meta: {
      title: "Quem foi Jean Piaget?",
      mod: "jeanPiaget"
    }
  },
  {
    path: "/institucional/proposta-pedagogica",
    name: "Proposta Pedagógica",
    component: Institucional,
    meta: {
      title: "Proposta Pedagógica",
      mod: "pedagogicalProposal"
    }
  },
  {
    path: "/ensino",
    name: "Ensino",
    component: Education
  },
  {
    path: "/novidades/noticias",
    name: "Notícias",
    component: ArticleList
  },
  {
    path: "/novidades/noticias/:item",
    name: "Notícia",
    component: ArticleItem
  },
  {
    path: "/novidades/galerias",
    name: "Galerias",
    component: GalleryList
  },
  {
    path: "/novidades/galerias/:item",
    name: "Galeria",
    component: GalleryItem
  },
  {
    path: "/novidades/videos",
    name: "Vídeos",
    component: VideoList
  },
  {
    path: "/novidades/videos/:item",
    name: "Vídeo",
    component: VideoItem
  },
  {
    path: "/novidades/projetos",
    name: "Projetos",
    component: ProjectList
  },
  {
    path: "/novidades/projetos/:item",
    name: "Projeto",
    component: ProjectItem
  },
  {
    path: "/novidades/comunicados",
    name: "Comunicados da Escola",
    component: CommunicationList
  },
  {
    path: "/novidades/comunicados/:item",
    name: "Comunicado da Escola",
    component: CommunicationItem
  },
  {
    path: "/aluno/atividades-e-compromissos",
    name: "Atividades e Compromissos",
    component: ScheduleList
  },
  {
    path: "/aluno/atividades-e-compromissos/:item",
    name: "Atividade e Compromisso",
    component: ScheduleItem
  },
  {
    path: "/aluno/links-uteis",
    name: "Links Úteis",
    component: Links
  },
  {
    path: "/aluno/dicas-interessantes",
    name: "Dicas Interessantes",
    component: Tips
  },
  {
    path: "/aluno/licao-de-casa",
    name: "Lições de Casa",
    component: HomeworkList
  },
  {
    path: "/aluno/licao-de-casa/:item",
    name: "Lição de Casa",
    component: HomeworkItem
  },
  {
    path: "/calendario",
    name: "Calendário",
    component: DocumentList,
    meta: {
      title: "Calendários",
      mod: "calendars"
    }
  },
  {
    path: "/horario-de-aulas",
    name: "Horário de Aulas",
    component: DocumentList,
    meta: {
      title: "Horário de Aulas",
      mod: "classSchedule"
    }
  },
  // {
  //   path: "/carta-aos-pais",
  //   name: "Carta aos Pais",
  //   component: DocumentList
  // },
  {
    path: "/destaques",
    name: "Destaques",
    // component: DocumentList
    component: UnderConstruction
  },
  {
    path: "/contato",
    name: "Contato",
    component: Contact
  },
  {
    path: "/biblioteca",
    name: "Biblioteca",
    component: Books
  },
  {
    path: "/sala-de-matriculas",
    name: "Sala de Matrículas",
    component: PreRegistration
  },
  {
    path: "/boletim-coronavirus",
    name: "Boletim Coronavirus",
    component: Covid
  },
  {
    path: "/web-canal",
    name: "Web Canal",
    component: WebCanal
  },
  {
    path: "/enem",
    name: "Enem",
    component: Enem
  },
  {
    path: "/error404",
    name: "Erro 404",
    component: Error404
  },
  {
    path: "*",
    beforeEnter: (to, from, next) => {
      next("/error404");
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;
